import { render, staticRenderFns } from "./Ordercard.vue?vue&type=template&id=1c4df1b8&"
import script from "./Ordercard.vue?vue&type=script&lang=js&"
export * from "./Ordercard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports